import { Dialog } from "@headlessui/react";
import { api } from "../../lib/api";

interface Illustration {
  id: string;
  title: string;
  storage_path: string;
}

interface IllustrationSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  illustrations: Illustration[];
  onSelect: (illustration: Illustration) => void;
}

export function IllustrationSelectorModal({
  isOpen,
  onClose,
  illustrations,
  onSelect,
}: IllustrationSelectorModalProps) {
  const getThumbnailUrl = (storagePath: string) =>
    api.getImageUrl(storagePath, { width: 240 });

  return (
    <Dialog as="div" className="relative z-50" onClose={onClose} open={isOpen}>
      <div className="fixed inset-0 bg-black bg-opacity-25" />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all">
            <Dialog.Title
              as="h3"
              className="text-lg font-medium leading-6 text-gray-900 mb-4"
            >
              イラストを選択
            </Dialog.Title>

            <div className="grid grid-cols-4 gap-3 max-h-[60vh] overflow-y-auto">
              {illustrations.map((illustration) => (
                <div
                  key={illustration.id}
                  className="border rounded-lg p-2 hover:border-indigo-500 cursor-pointer transition-all"
                  onClick={() => onSelect(illustration)}
                >
                  <div className="aspect-square mb-1">
                    <img
                      src={getThumbnailUrl(illustration.storage_path)}
                      alt={illustration.title}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <p className="text-xs text-center text-gray-700 truncate">
                    {illustration.title}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-4 flex justify-end">
              <button
                type="button"
                className="inline-flex justify-center rounded-md border border-transparent bg-gray-100 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2"
                onClick={onClose}
              >
                閉じる
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
